import { Grid } from '@mui/material';

import React from 'react';
import PropTypes from 'prop-types';

import Viewpayer from './Viewpayer';

function Payer({ renderHandleFromChild, openAddPayerModal }) {
	return (
		<Grid container>
			<Grid item xs={12} lg={12} xl={12}>
				<Viewpayer
					renderHandleFromChild={renderHandleFromChild}
					openAddPayerModal={openAddPayerModal}
				/>
			</Grid>
		</Grid>
	);
}

Payer.propTypes = {
	renderHandleFromChild: PropTypes.func,
	openAddPayerModal: PropTypes.func,
};

export default Payer;
